module.exports = __webpack_public_path__ + "static/media/s_v8_t4.e8408dab.mp3";